<template>
  <div class="container remove-padding-margin">
    <div class="header-top bg-white">
      <div class="row justify-content-center align-items-center set-row w-limit">
        <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="back">
          <img src="../../assets/gambar/back-blue.svg" alt="" />
        </div>
        <div class="col-md-7 col-sm-7 col-7 text-center remove-padding">
          <h6 class="remove-margin font-16 font-colorcheck text-promo">Tambah Layanan</h6>
        </div>
        <div class="col-md-2 col-sm-2 col-2 remove-padding"></div>
      </div>
    </div>
    <main class="add-padding-default w-limit">
      <div class="flex-100">
        <div class="flex-1 pad-top-66">
          <form action="">
            <div class="form-group">
              <label class="remove-margin require" for="namalayanan">Nama Layanan</label>
              <input
                type="text"
                class="form-control inputs"
                id="namalayanan"
                aria-describedby="emailHelp"
                placeholder="Cuci Kering Setrika"
                v-model="nama_layanan"
                v-on:keyup="nameonly"
              />
              <ErrorMessage
                class="error"
                label="Nama Layanan"
                :validation="$v.nama_layanan"
                ref="errmsg_nama_layanan"
              ></ErrorMessage>

              <div class="form-row">
                <div class="form-group col-md-6 col-sm-6 col-6">
                  <label class="remove-margin mar-top-12 require" for="phone">Harga</label>
                  <!--<div class="input-group remove-padding">-->
                  <!--    <div class="input-group-prepend">-->
                  <!--        <div class="input-group-text">Rp</div>-->
                  <!--    </div>-->
                  <!--    <input type="tel" class="form-control inputs" id="phone" placeholder="14000"  value="" v-model="harga_layanan_create" v-on:keyup="numberonlycreate">-->
                  <!--</div>-->
                  <InputRupiah
                    :outerDivClass="'input-group remove-padding'"
                    v-model="harga_layanan_create"
                    :showRp="true"
                    :placeholder="14000"
                    :comma="false"
                  />
                  <ErrorMessage
                    class="error"
                    label="Harga"
                    :validation="$v.harga_layanan_create.raw"
                    ref="errmsg_harga_layanan_create"
                  ></ErrorMessage>
                </div>

                <div class="form-group col-md-6 col-sm-6 col-6">
                  <label class="remove-margin mar-top-12 require" for="phone">Per</label>
                  <select class="form-control" v-model="selected" v-on:change="cekValidate">
                    <option value="" selected>Pilih Satuan</option>
                    <option
                      v-for="(option, idx) in satuan_layanan"
                      v-bind:value="{ value: option.value, text: option.text }"
                      :key="`layanan${idx}`"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                  <ErrorMessage
                    class="error"
                    label="Satuan"
                    :validation="$v.selected"
                    ref="errmsg_selected"
                  ></ErrorMessage>
                </div>
              </div>
              <div><label class="remove-margin  require" for="phone">Durasi Pengerjaan</label></div>
              <div class="row remove-padding-margin">
                <div class="col-md-6 col-sm-6 col-6 remove-padding" style="padding-right: 4px">
                  <InputMinPlus
                    v-model="durasi_hari"
                    :id="'hari'"
                    :minValue="0"
                    :maxValue="31"
                    :metric="'Hari'"
                    ref="inputhariref"
                  />
                  <ErrorMessage
                    class="error"
                    label="Durasi Pengerjaan"
                    :validation="$v.durasi_hari"
                    ref="errmsg_durasi_hari"
                  ></ErrorMessage>
                </div>
                <div class="col-md-6 col-sm-6 col-6 remove-padding text-right" style="padding-left: 4px">
                  <InputMinPlus
                    v-model="durasi_jam"
                    :id="'jam'"
                    :minValue="0"
                    :maxValue="23"
                    :metric="'Jam'"
                    ref="inputjamref"
                  />
                  <ErrorMessage
                    class="error"
                    label="Durasi Pengerjaan"
                    :validation="$v.durasi_jam"
                    ref="errmsg_durasi_jam"
                  ></ErrorMessage>
                </div>
              </div>
            </div>
          </form>
          <div class="lebih-sedikit text-alignC" @click="showmore" id="nomore">
            <h6 class="remove-padding-margin color-206CF">
              Pengaturan Lanjutan
              <span>
                <img class="rotate" src="../../assets/icons/chevron-rotate-down.svg" alt="" />
              </span>
            </h6>
          </div>
          <form action="">
            <div class="form-group animated" id="more">
              <label class="remove-margin mar-top-20">Kategori Layanan</label>
              <select class="form-control tagging" id="suggestData" multiple="true" v-on:keyup="cekValidate">
                <option v-if="suggestarray !== 0" v-for="option in suggestarray">
                  {{ option.text }}
                </option>
              </select>
              <div
                class="custom-control custom-switch mar-top-20"
                style="padding: 0px 12px"
                id="togleorder"
                @click="ordercreate"
              >
                <input type="checkbox" class="custom-control-input" id="togleorder1" />
                <label class="custom-control-label font-14 font-weight-bold" for="togleorder1"
                  >Aktifkan minimal order</label
                >
              </div>
              <div class="form-row" id="order" style="display: none">
                <div class="form-group col-md-6 col-sm-6 col-6">
                  <label class="remove-margin mar-top-12" for="reguler">Min. Order Reguler</label>
                  <InputRupiah
                    :outerDivClass="'input-group remove-padding'"
                    v-model="order_reguler"
                    @input="order_reguler"
                    :showRp="true"
                    :showRpPosition="'right'"
                    :showRpText="selected === '' ? '.' : selected.text"
                    :placeholder="10"
                    ref="minregulerref"
                  />
                  <!--<div class="input-group remove-padding">-->
                  <!--    <input type="tel" class="form-control" id="reguler" placeholder="" v-model="order_reguler" v-on:keyup="inputreguler" @keydown="inputreguler">-->
                  <!--    <div class="input-group-prepend">-->
                  <!--        <div class="input-group-text">{{selected.text}}</div>-->
                  <!--    </div>-->
                  <!--</div>-->
                </div>
                <div class="form-group col-md-6 col-sm-6 col-6">
                  <label class="remove-margin mar-top-12" for="deposit">Min Order deposit</label>
                  <InputRupiah
                    :outerDivClass="'input-group remove-padding'"
                    v-model="order_deposit"
                    @input="order_deposit"
                    :showRp="true"
                    :showRpPosition="'right'"
                    :showRpText="selected === '' ? '.' : selected.text"
                    :placeholder="10"
                    ref="mindepositref"
                  />
                  <!--<div class="input-group remove-padding">-->
                  <!--    <input type="tel" class="form-control" id="deposit" placeholder="" v-model="order_deposit" v-on:keyup="inputdeposit" @keydown="inputdeposit">-->
                  <!--    <div class="input-group-prepend">-->
                  <!--        <div class="input-group-text">{{selected.text}}</div>-->
                  <!--    </div>-->
                  <!--</div>-->
                </div>
              </div>
              <div class="custom-control custom-switch mar-top-20" style="padding: 0px 12px" @click="upahcreate">
                <input type="checkbox" class="custom-control-input" id="togleupah1" />
                <label class="custom-control-label font-14 font-weight-bold" for="togleupah1"
                  >Aktifkan upah borongan</label
                >
              </div>
              <div class="popup p-t-16" id="upah" style="display: none">
                <!--<form action="">-->
                <!--    <div class="form-row" >-->
                <!--        <div class="form-group col-md-6 col-sm-6 col-6" v-for="tahapanlayanan in tahapan" :key="tahapanlayanan.idtahapan">-->
                <!--            <label class="remove-margin mar-top-12" v-bind:for="tahapanlayanan.idtahapan">{{tahapanlayanan.text}}</label>-->
                <!--            <div class="input-group remove-padding">-->
                <!--             &lt;!&ndash;<input type="tel" class="form-control inputs upah" id="tahapan" value="0" v-bind:id="tahapanlayanan.idtahapan" placeholder="" v-on:keyup="max100(tahapanlayanan.idtahapan)">&ndash;&gt;-->
                <!--             <InputPersentase v-model="upahBorongan[tahapanlayanan.idtahapan]" :defaultValue="upahBorongan[tahapanlayanan.idtahapan].raw"-->
                <!--                              :class="'form-control inputs'"/>-->
                <!--             <div class="input-group-prepend">-->
                <!--                    <div class="input-group-text">%</div>-->
                <!--                </div>-->
                <!--            </div>-->
                <!--        </div>-->
                <!--    </div>-->
                <!--</form>-->
                <UpahBoronganComponentV2
                  :harga-layanan="harga_layanan_create.raw"
                  :tahapan="tahapan"
                  @upah="
                    (val) => {
                      resultUpah = val;
                    }
                  "
                />
              </div>
            </div>
          </form>
        </div>
        <div class="button-lanjut">
          <button
            type="button"
            class="btn btn-outline-primary btn-long"
            @click="postLayananaddV2"
            :disabled="isClicked2"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
              v-if="isClicked2 === true"
            ></span
            ><span v-if="!isClicked2">Simpan & tambah lainnya</span>
          </button>
          <button type="button" class="btn btn-login btn-long" @click="postLayananV2" :disabled="isClicked1">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
              v-if="isClicked1 === true"
            ></span
            ><span v-if="!isClicked1">Simpan</span>
          </button>
        </div>
      </div>
    </main>
    <div class="modal fade" id="modalOut" role="dialog">
      <div class="modal-dialog modal-lg  bani-modal">
        <div class="modal-content w-limit">
          <div class="modal-header">
            <div class="nav-btn kiri"></div>
            <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
            <div class="nav-btn kanan tutup"></div>
          </div>
          <div class="modal-body">
            <p>
              Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode panduan. Apakah
              Anda yakin ingin keluar dari panduan?
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary btn-long m-d-20"
              @click="closeModal"
              data-dismiss="modal"
            >
              Lanjutkan Panduan
            </button>
            <a @click="skipOnboarding(3)" class="m-t-20 f-semi f-12 f-c-blue">Saya Ingin Keluar Dari Mode Panduan</a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal" role="dialog">
      <div class="modal-dialog modal-lg  bani-modal">
        <div class="modal-content w-limit">
          <div class="modal-header">
            <div class="nav-btn kiri"></div>
            <h5 class="navbar-title text-center">Batal Membuat Layanan</h5>
            <div class="nav-btn kanan tutup">
              <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="" />
            </div>
          </div>
          <div class="modal-body">
            <p>Apakah anda yakin ingin membatalkan pembuatan Layanan baru?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" @click="emitBack">
              Ya, Batalkan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import InputMinPlus from "../../component-items/InputMinPlus";
import InputPersentase from "@/component-items/InputPersentase";
import InputRupiah from "@/component-items/InputRupiah";
import ErrorMessage from "@/component-items/ErrorMessage";
import { minValue, minLength, required } from "vuelidate/lib/validators";

import UpahBoronganComponent from "@/components/Layanan/UpahBoronganComponent";
import UpahBoronganComponentV2 from "@/components/Layanan/UpahBoronganComponentV2";

export default {
  name: "TambahLayanan",
  components: { Select2, InputMinPlus, InputPersentase, ErrorMessage, InputRupiah, UpahBoronganComponentV2 },
  props: ["setidoutletsetservice", "setidoutlet"],
  data() {
    return {
      nama: "",
      nama_layanan: "",
      harga_layanan_create: {
        raw: 0,
        formatted: "",
      },
      satuan_layanan: [],
      tahapan: [],
      defaulttahapan: [],
      suggestarray: [],
      isClicked: false,
      isClicked1: false,
      isClicked2: false,
      selected: "",
      idoutlet: this.setidoutletsetservice,
      durasi_hari: 0,
      durasi_jam: 0,
      order_reguler: {
        formatted: "",
        raw: 0,
      },
      order_deposit: {
        formatted: "",
        raw: 0,
      },
      lengthLayanan: 0,
      tagLayanan: [],
      requestHeaders: {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      },

      upahBorongan: [],
      resultUpah: {},

      regexEmoji: {
        name: /[^0-9A-Za-z_.,/'& -]+/g,
        percent: /[^0-9.,]+/g,
      },
    };
  },
  validations: {
    nama_layanan: {
      required,
      minLength: minLength(2),
    },
    harga_layanan_create: {
      raw: {
        required,
        minValue: minValue(1),
      },
    },
    selected: {
      required,
    },
    durasi_hari: {
      required,
    },
    durasi_jam: {
      required,
    },
  },
  mounted() {
    this.idoutlet = this.$route.params.idoutlet;
    $(".more").hide();
    this.tagging();
    $("#more").hide();
    this.getsatuanMeta();
    this.gettahapan();
    this.cekValidate();
    this.suggest();
    $("#close").hide();
    $("#closeS").hide();

    $(document).on("keyup", ".select2-search__field", () => {
      var val = $(".select2-search__field")
        .val()
        .replace(/[^a-zA-Z .,'-]+/g, "");
      $(".select2-search__field").val(val);
    });

    this.backButtonPressed(this.back);
  },
  watch: {
    durasi_hari: function() {
      this.cekValidate();
    },
    durasi_jam: function() {
      this.cekValidate();
    },

    nama_layanan: function() {
      this.nama_layanan = this.nama_layanan.replace(this.regexEmoji.name, "");
    },
  },
  methods: {
    tagging() {
      $(".tagging").select2({
        placeholder: "Ketuk Untuk Menambah Tag", //placeholder
        tags: true,
        createTag: function(params) {
          var term = $.trim(params.term);
          term = term.replace(/[^a-zA-Z .,'-]+/g, "");

          return {
            id: term,
            text: term,
            newTag: true, // add additional parameters
          };
        },
      });
      // this.cekValidate()
    },
    back() {
      const stepWalkthrough = localStorage.getItem("step_walkthrough");
      if (stepWalkthrough != undefined && stepWalkthrough != null && stepWalkthrough == "1") {
        $("#modalOut").modal("show");
      } else {
        $("#modal").modal("show");
      }
    },
    closeModal() {
      $("#modalOut").modal("hide");
    },
    emitBack() {
      this.$emit("gotolistlayanan");
    },
    async skipOnboarding(params) {
      $("#loadingPage").show();
      $("#loadingPage").addClass("overlayLoading");
      try {
        const datawalkthrough = new FormData();
        datawalkthrough.append("walkthrough", params);
        const response = await this.$axios.post(
          this.$baseurl + "/masterData/owner/update_status_walkthrough",
          datawalkthrough,
          this.requestHeaders
        );
        if (response.data.code === 200) {
          if (response.data.status === true) {
            localStorage.setItem("step_walkthrough", params);
            this.emitBack();
            $("#modalOut").modal("hide");
            $("#loadingPage").hide();
            $("#loadingPage").removeClass("overlayLoading");
          }
        } else {
          $("#loadingPage").hide();
          $("#loadingPage").removeClass("overlayLoading");
          this.popupType = "error";
          this.popupMessage = response.data.msg;
        }
      } catch (e) {
        if (!e.code) {
          $("#loadingPage").hide();
          $("#loadingPage").removeClass("overlayLoading");
          this.popupType = "error";
          this.popupErrorException = e;
        }
      }
    },
    rotate() {
      $(".rotate").toggleClass("down");
    },

    showmore() {
      $("#more").slideToggle(400);
      this.rotate();
    },

    nameonly(event) {
      var nums = event.target.value;
      var number = nums.replace(this.regexEmoji, "");
      this.nama_layanan = number;
      this.cekValidate();
    },

    numberonlycreate(event) {
      var nums = event.target.value;
      var numbercreate = nums.replace(/[^0-9]+/, "");
      this.harga_layanan_create = numbercreate;
      this.formatrupiahcreate(event);
      this.cekValidate();
    },

    formatrupiahcreate(event) {
      var rupiah = event.target.value;
      var formattedrupiahcreate = this.newrupiahcreate(rupiah);
      this.harga_layanan_create = formattedrupiahcreate;
    },

    newrupiahcreate(angka, prefix) {
      /* Fungsi formatRupiah */
      var number_string = angka.replace(/[^,\d]/g, "").toString(),
        split = number_string.split(","),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);
      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (ribuan) {
        var separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
      return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
    },

    ordercreate(e) {
      // $('#customSwitch2').slideToggle(400)
      e.preventDefault();
      if (!$("#togleorder1").is(":checked")) {
        $("#order").slideDown(400);
        $("#togleorder1").prop("checked", true);
      } else {
        $("#order").slideUp(400);
        $("#togleorder1").prop("checked", false);
      }
    },

    upahcreate(e) {
      e.preventDefault();
      if (!$("#togleupah1").is(":checked")) {
        $("#upah").slideDown(400);
        $("#togleupah1").prop("checked", true);
      } else {
        $("#upah").slideUp(400);
        $("#togleupah1").prop("checked", false);
      }
    },

    inputreguler(event) {
      // let key = event.which || event.keyCode
      // if (key && (key <= 47 || key >= 58)) {
      //     event.preventDefault();
      // }
      var nums = event.target.value;
      var number = nums.replace(/[^0-9.]+/, "");
      this.order_reguler = number;
      this.formatrupiahorder(event);
    },

    formatrupiahorder(event) {
      var rupiah = event.target.value;
      if (rupiah.includes(".")) {
        var decimalCheck = rupiah.substr(rupiah.indexOf("."));
        if (decimalCheck.length > 1) {
          if (decimalCheck.substring(1).includes(".")) {
            var decimalCheckReplace = decimalCheck.substring(1).replace(".", "");
            this.order_reguler = rupiah.replace(decimalCheck, "." + decimalCheckReplace);
            return;
          }
        } else {
          return;
        }
      }
      rupiah = parseFloat(rupiah).toString();
      var formattedrupiah = this.newrupiahorder(rupiah);
      this.order_reguler = formattedrupiah;
    },

    newrupiahorder(angkareguler, prefixreguler) {
      /* Fungsi formatRupiah */
      var number_string = angkareguler.replace(/[^.\d]/g, "").toString(),
        split = number_string.split("."),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);
      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (ribuan) {
        var separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      if (split[1] !== undefined) {
        if (split[1].length >= 2) {
          if (parseFloat(split[1]) === 0) {
            return 0;
          } else {
            return rupiah + "." + split[1].substr(0, 2);
          }
        }
      }
      rupiah = split[1] != undefined ? rupiah + "." + split[1] : rupiah;
      return prefixreguler == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
    },

    inputdeposit(event) {
      // let key = event.which || event.keyCode
      // if (key && (key <= 47 || key >= 58)) {
      //     event.preventDefault();
      // }
      var nums = event.target.value;
      var number = nums.replace(/[^0-9.]+/, "");
      this.order_deposit = number;
      this.formatrupiahdeposit(event);
    },

    formatrupiahdeposit(event) {
      var rupiah = event.target.value;
      if (rupiah.includes(".")) {
        var decimalCheck = rupiah.substr(rupiah.indexOf("."));
        if (decimalCheck.length > 1) {
          if (decimalCheck.substring(1).includes(".")) {
            var decimalCheckReplace = decimalCheck.substring(1).replace(".", "");
            this.order_deposit = rupiah.replace(decimalCheck, "." + decimalCheckReplace);
            return;
          }
        } else {
          return;
        }
      }
      rupiah = parseFloat(rupiah).toString();
      var formattedrupiah = this.newrupiahdeposit(rupiah);
      this.order_deposit = formattedrupiah;
    },

    newrupiahdeposit(angkaupah, prefixupah) {
      /* Fungsi formatRupiah */
      var number_string = angkaupah.replace(/[^.\d]/g, "").toString(),
        split = number_string.split("."),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);
      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (ribuan) {
        var separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      if (split[1] !== undefined) {
        if (split[1].length >= 2) {
          if (parseFloat(split[1]) === 0) {
            return 0;
          } else {
            return rupiah + "." + split[1].substr(0, 2);
          }
        }
      }

      rupiah = split[1] != undefined ? rupiah + "." + split[1] : rupiah;
      return prefixupah == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
    },

    max100(key) {
      var inputkomisi = $("#" + key).val();
      // $('.upah').keyup(function(){
      if (inputkomisi > 100) {
        $("#" + key).val("100");
      }
      // });
      this.upahinput(key);
      this.decimal(key);
    },

    upahinput(key) {
      var handleeventkomisi = $("#" + key).val();
      var handlenumber = handleeventkomisi.replace(/[^0-9.]+/, "");
      $("#" + key).val(handlenumber);
      // var nums = event.target.value;
      // var number = nums.replace(/[^0-9]+/, '');
      // event.target.value = number;
    },

    decimal(key) {
      $("#" + key).keydown(function(e) {
        //Get the occurence of decimal operator
        var match = $(this)
          .val()
          .match(/\./g);
        if (match != null) {
          // Allow: backspace, delete, tab, escape and enter
          if (
            $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)
          ) {
            // let it happen, don't do anything
            return;
          } // Ensure that it is a number and stop the keypress
          else if (
            (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
            (e.keyCode < 96 || e.keyCode > 105) &&
            e.keyCode == 190
          ) {
            e.preventDefault();
          }
        } else {
          // Allow: backspace, delete, tab, escape, enter and .
          if (
            $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)
          ) {
            // let it happen, don't do anything
            return;
          }
          // Ensure that it is a number and stop the keypress
          if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
          }
        }
      });

      $("#" + key).keyup(function() {
        if (
          $(this)
            .val()
            .indexOf(".") != -1
        ) {
          if (
            $(this)
              .val()
              .split(".")[1].length >= 2
          ) {
            if (isNaN(parseFloat(this.value))) return;
            this.value = parseFloat(this.value).toFixed(2);
          }
        }
      });
    },

    cekValidate() {
      return;
      var NamaLayanan = this.nama_layanan;
      var HargaLayanan = this.harga_layanan_create;
      var DurasiHari = this.durasi_hari;
      var DurasiJam = this.durasi_jam;
      var select = this.selected;
      var lenPass = NamaLayanan.length;

      if (
        lenPass >= 2 &&
        select !== "" &&
        HargaLayanan.length >= 3 && HargaLayanan.length <= 10 &&
        DurasiHari >= 0 && DurasiJam >= 0
      ) {
        $("#btnNextCreateLayanan").prop("disabled", false);
        $("#anotherButton").prop("disabled", false);
        if (DurasiHari === 0 && DurasiJam === 0) {
          $("#btnNextCreateLayanan").prop("disabled", true);
        }
      } else {
        $("#btnNextCreateLayanan").prop("disabled", true);
        $("#anotherButton").prop("disabled", true);
      }
    },

    async getsatuanMeta() {
      this.isClicked = true;
      $("#loadingPage").addClass("overlayLoading");
      try {
        const satuan = new FormData();
        const response = await this.$axios.get(this.$baseurl + "/masterData/meta/satuan_meta", this.requestHeaders);
        if (response.status === 200) {
          var layanan = response.data.data;
          for (var i = 0; i < layanan.length; i++) {
            // if (layanan[i].iddata_satuan !== 14) {
            this.satuan_layanan.push({
              value: layanan[i].iddata_satuan,
              text: layanan[i].nama,
            });
            // }
          }
          this.isClicked = false;
          $("#loadingPage").removeClass("overlayLoading");
        } else {
        }
      } catch (e) {}
    },

    async postLayanan() {
      if (this.errorValidation()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      this.isClicked1 = true;
      $("#textBtn2").hide();
      $("#btnNextCreateLayanan").prop("disabled", true);
      var dataTags = $("#suggestData").select2("data");
      try {
        const create = new FormData();
        if (parseInt(this.durasi_hari) === 0 && parseInt(this.durasi_jam) === 0) {
          this.$toast.error("Durasi tidak boleh kosong");
          this.isClicked1 = false;
          $("#textBtn2").show();
          $("#btnNextCreateLayanan").prop("disabled", false);
          return;
        }
        create.append("durasi_penyelesaian_hari", this.durasi_hari);
        create.append("durasi_penyelesaian_jam", this.durasi_jam);
        for (var i = 0; i < dataTags.length; i++) {
          create.append("tags[]", dataTags[i].text);
        }
        var inputTahapan = this.tahapan;
        for (var idtahapan in this.upahBorongan) {
          create.append(idtahapan, this.upahBorongan[idtahapan].formatted);
        }
        create.append("nama_layanan", this.nama_layanan);
        create.append("idsatuan", this.selected.value);
        create.append("harga", this.harga_layanan_create.formatted);
        create.append("jumlah", "1");
        create.append("idoutlet", this.setidoutletsetservice);
        create.append("idowner", localStorage.getItem("idowner"));
        create.append("min_order_reg", this.order_reguler);
        create.append("min_order_depo", this.order_deposit);
        const response = await this.$axios.post(
          this.$baseurl + "/masterData/layanan/create_layanan",
          create,
          this.requestHeaders
        );
        if (response.data.status === true) {
          this.updateStepWalkthrough();
          this.$emit("gotolistlayanan");
          this.isClicked1 = false;
          $("#textBtn2").show();
          $("#btnNextCreateLayanan").prop("disabled", false);
          this.$toast.success(response.data.msg);
        } else {
          this.isClicked1 = false;
          $("#textBtn2").show();
          $("#btnNextCreateLayanan").prop("disabled", false);
          this.$toast.error(response.data.msg);
        }
        // create.append('min_order_reg',$('#reguler').val())
      } catch (e) {
        this.$catch_error_response(e);
        this.isClicked1 = false;
        $("#textBtn2").show();
        $("#btnNextCreateLayanan").prop("disabled", false);
      }
    },
    async postLayananV2() {
      if (this.errorValidation()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      this.isClicked1 = true;
      $("#textBtn2").hide();
      $("#btnNextCreateLayanan").prop("disabled", true);
      var dataTags = $("#suggestData").select2("data");
      try {
        const create = new FormData();
        if (parseInt(this.durasi_hari) === 0 && parseInt(this.durasi_jam) === 0) {
          this.$toast.error("Durasi tidak boleh kosong");
          this.isClicked1 = false;
          $("#textBtn2").show();
          $("#btnNextCreateLayanan").prop("disabled", false);
          return;
        }
        create.append("durasi_penyelesaian_hari", this.durasi_hari);
        create.append("durasi_penyelesaian_jam", this.durasi_jam);
        for (var i = 0; i < dataTags.length; i++) {
          create.append("tags[]", dataTags[i].text);
        }
        for (let i = 0; i < this.tahapan.length; i++) {
          let id = this.tahapan[i].idtahapan;
          create.append(this.resultUpah[id].rupiah.idtahapan, this.resultUpah[id].rupiah.raw);
        }
        create.append("nama_layanan", this.nama_layanan);
        create.append("idsatuan", this.selected.value);
        create.append("harga", this.harga_layanan_create.formatted);
        create.append("jumlah", "1");
        create.append("idoutlet", this.setidoutletsetservice);
        create.append("idowner", localStorage.getItem("idowner"));
        create.append("min_order_reg", this.order_reguler.raw);
        create.append("min_order_depo", this.order_deposit.raw);
        const response = await this.$axios.post(
          this.$baseurl + "/masterData/layanan/create_layanan_v2",
          create,
          this.requestHeaders
        );
        if (response.data.status === true) {
          this.updateStepWalkthrough();
          this.$emit("gotolistlayanan");
          this.isClicked1 = false;
          $("#textBtn2").show();
          $("#btnNextCreateLayanan").prop("disabled", false);
          this.$toast.success(response.data.msg);
        } else {
          this.isClicked1 = false;
          $("#textBtn2").show();
          $("#btnNextCreateLayanan").prop("disabled", false);
          this.$toast.error(response.data.msg);
        }
        // create.append('min_order_reg',$('#reguler').val())
      } catch (e) {
        this.$catch_error_response(e);
        this.isClicked1 = false;
        $("#textBtn2").show();
        $("#btnNextCreateLayanan").prop("disabled", false);
      }
    },
    async updateStepWalkthrough() {
      if (localStorage.getItem("step_walkthrough") !== undefined && localStorage.getItem("step_walkthrough") == "1") {
        var walkthrough = 2;
        try {
          const datawalkthrough = new FormData();
          datawalkthrough.append("walkthrough", walkthrough);
          const response = await this.$axios.post(
            this.$baseurl + "/masterData/owner/update_status_walkthrough",
            datawalkthrough,
            this.requestHeaders
          );
          if (response.data.code === 200) {
            if (response.data.status === true) {
              localStorage.setItem("step_walkthrough", walkthrough);
            }
          } else {
            this.popupType = "error";
            this.popupMessage = response.data.msg;
          }
        } catch (e) {
          if (!e.code) {
            this.popupType = "error";
            this.popupErrorException = e;
          }
        }
      }
    },
    errorValidation() {
      this.$v.nama_layanan.$touch();
      this.$v.harga_layanan_create.raw.$touch();
      this.$v.selected.$touch();
      this.$v.durasi_hari.$touch();
      this.$v.durasi_jam.$touch();
      return (
        this.$v.nama_layanan.$invalid ||
        this.$v.harga_layanan_create.raw.$invalid ||
        this.$v.selected.$invalid ||
        this.$v.durasi_hari.$invalid ||
        this.$v.durasi_jam.$invalid
      );
    },
    async postLayananadd() {
      if (this.errorValidation()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      this.isClicked2 = true;
      $("#textBtnother").hide();
      $("#anotherButton").prop("disabled", true);
      var dataTags = $("#suggestData").select2("data");
      try {
        if (parseInt(this.durasi_hari) === 0 && parseInt(this.durasi_jam) === 0) {
          this.$toast.error("Durasi tidak boleh kosong");
          this.isClicked2 = false;
          $("#textBtnother").show();
          $("#anotherButton").prop("disabled", false);
          return;
        }
        const createadd = new FormData();
        createadd.append("durasi_penyelesaian_hari", this.durasi_hari);
        createadd.append("durasi_penyelesaian_jam", this.durasi_jam);
        for (var i = 0; i < dataTags.length; i++) {
          createadd.append("tags[]", dataTags[i].text);
        }
        var inputTahapan = this.tahapan;
        for (var x = 0; x < inputTahapan.length; x++) {
          createadd.append(inputTahapan[x].idtahapan, $("#" + inputTahapan[x].idtahapan).val());
        }
        createadd.append("nama_layanan", this.nama_layanan);
        createadd.append("idsatuan", this.selected.value);
        createadd.append("harga", this.harga_layanan_create.formatted);
        createadd.append("jumlah", "1");
        createadd.append("idoutlet", this.setidoutletsetservice);
        createadd.append("idowner", localStorage.getItem("idowner"));
        createadd.append("min_order_reg", this.order_reguler);
        createadd.append("min_order_depo", this.order_deposit);
        const response = await this.$axios.post(
          this.$baseurl + "/masterData/layanan/create_layanan",
          createadd,
          this.requestHeaders
        );
        if (response.status === 200) {
          if (response.data.status === true) {
            // this.GetLengthLayanan()
            this.updateStepWalkthrough();
            this.isClicked2 = false;
            $("#textBtnother").show();
            $("#anotherButton").prop("disabled", false);
            this.nama_layanan = "";
            this.harga_layanan_create.formatted = "";
            this.harga_layanan_create.raw = 0;
            this.tahapan = this.defaulttahapan;
            for (var x = 0; x < inputTahapan.length; x++) {
              createadd.append(inputTahapan[x].idtahapan, $("#" + inputTahapan[x].idtahapan).val(0));
            }
            this.durasi_hari = 0;
            this.durasi_jam = 0;
            this.order_reguler = 0;
            this.order_deposit = 0;
            this.$refs.inputhariref.changeVal(0);
            this.$refs.inputjamref.changeVal(0);
            $("#suggestData")
              .val("")
              .trigger("change");
            this.selected = "";
            $("#togleorder1").prop("checked", false);
            $("#togleupah1").prop("checked", false);
            $("#upah").slideUp(400);
            $("#order").slideUp(400);
            this.cekValidate();
            this.$toast.success(response.data.msg);

            this.$refs.errmsg_nama_layanan.resetValidation();
            this.$refs.errmsg_harga_layanan_create.resetValidation();
            this.$refs.errmsg_selected.resetValidation();
            this.$refs.errmsg_durasi_hari.resetValidation();
            this.$refs.errmsg_durasi_jam.resetValidation();
          } else {
            this.isClicked2 = false;
            $("#textBtnother").show();
            $("#anotherButton").prop("disabled", false);
            this.$toast.error(response.data.msg);
          }
        }
      } catch (e) {
        this.$catch_error_response(e);
        this.isClicked2 = false;
        $("#textBtnother").show();
        $("#anotherButton").prop("disabled", false);
      }
    },
    async postLayananaddV2() {
      if (this.errorValidation()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      this.isClicked2 = true;
      $("#textBtnother").hide();
      $("#anotherButton").prop("disabled", true);
      var dataTags = $("#suggestData").select2("data");
      try {
        if (parseInt(this.durasi_hari) === 0 && parseInt(this.durasi_jam) === 0) {
          this.$toast.error("Durasi tidak boleh kosong");
          this.isClicked2 = false;
          $("#textBtnother").show();
          $("#anotherButton").prop("disabled", false);
          return;
        }
        const createadd = new FormData();
        createadd.append("durasi_penyelesaian_hari", this.durasi_hari);
        createadd.append("durasi_penyelesaian_jam", this.durasi_jam);
        for (var i = 0; i < dataTags.length; i++) {
          createadd.append("tags[]", dataTags[i].text);
        }
        var inputTahapan = this.tahapan;
        for (let i = 0; i < this.tahapan.length; i++) {
          let id = this.tahapan[i].idtahapan;
          createadd.append(this.resultUpah[id].rupiah.idtahapan, this.resultUpah[id].rupiah.raw);
        }
        createadd.append("nama_layanan", this.nama_layanan);
        createadd.append("idsatuan", this.selected.value);
        createadd.append("harga", this.harga_layanan_create.formatted);
        createadd.append("jumlah", "1");
        createadd.append("idoutlet", this.setidoutletsetservice);
        createadd.append("idowner", localStorage.getItem("idowner"));
        createadd.append("min_order_reg", this.order_reguler.raw);
        createadd.append("min_order_depo", this.order_deposit.raw);
        const response = await this.$axios.post(
          this.$baseurl + "/masterData/layanan/create_layanan_v2",
          createadd,
          this.requestHeaders
        );
        if (response.status === 200) {
          if (response.data.status === true) {
            // this.GetLengthLayanan()
            this.updateStepWalkthrough();
            this.isClicked2 = false;
            $("#textBtnother").show();
            $("#anotherButton").prop("disabled", false);
            this.nama_layanan = "";
            this.harga_layanan_create.formatted = "";
            this.harga_layanan_create.raw = 0;
            this.tahapan = this.defaulttahapan;
            for (var x = 0; x < inputTahapan.length; x++) {
              createadd.append(inputTahapan[x].idtahapan, $("#" + inputTahapan[x].idtahapan).val(0));
            }
            this.durasi_hari = 0;
            this.durasi_jam = 0;
            this.order_reguler = {
              formatted: "",
              raw: 0,
            };
            this.$refs.minregulerref.getValRupiah("0");
            this.order_deposit = {
              formatted: "",
              raw: 0,
            };
            this.$refs.mindepositref.getValRupiah("0");
            this.$refs.inputhariref.changeVal(0);
            this.$refs.inputjamref.changeVal(0);
            $("#suggestData")
              .val("")
              .trigger("change");
            this.selected = "";
            $("#togleorder1").prop("checked", false);
            $("#togleupah1").prop("checked", false);
            $("#upah").slideUp(400);
            $("#order").slideUp(400);
            this.cekValidate();
            this.$toast.success(response.data.msg);

            this.$refs.errmsg_nama_layanan.resetValidation();
            this.$refs.errmsg_harga_layanan_create.resetValidation();
            this.$refs.errmsg_selected.resetValidation();
            this.$refs.errmsg_durasi_hari.resetValidation();
            this.$refs.errmsg_durasi_jam.resetValidation();
          } else {
            this.isClicked2 = false;
            $("#textBtnother").show();
            $("#anotherButton").prop("disabled", false);
            this.$toast.error(response.data.msg);
          }
        }
      } catch (e) {
        this.$catch_error_response(e);
        this.isClicked2 = false;
        $("#textBtnother").show();
        $("#anotherButton").prop("disabled", false);
      }
    },

    async gettahapan() {
      $("#loadingPage").show();
      $("#loadingPage").addClass("overlayLoading");
      try {
        const response = await this.$axios.get(this.$baseurl + "/masterData/meta/tahapan_meta", this.requestHeaders);
        if (response.status === 200) {
          var rawtahapan = response.data.data;
          for (var i = 0; i < rawtahapan.length; i++) {
            this.tahapan.push({ idtahapan: rawtahapan[i].idtahapan, text: rawtahapan[i].nama });
            this.upahBorongan[rawtahapan[i].idtahapan] = { raw: 0, formatted: "" };
          }
          this.defaulttahapan = this.tahapan;
        }
        $("#loadingPage").hide();
        $("#loadingPage").removeClass("overlayLoading");
      } catch (e) {
        this.$catch_error_response(e);
        $("#loadingPage").hide();
        $("#loadingPage").removeClass("overlayLoading");
      }
    },
    async suggest() {
      $("#loadingPage").show();
      $("#loadingPage").addClass("overlayLoading");
      try {
        const response = await this.$axios.get(
          this.$baseurl + "/masterData/meta/list_suggest_tags_layanan",
          this.requestHeaders
        );
        if (response.status === 200) {
          if (response.data.status === true) {
            $("#loadingPage").hide();
            $("#loadingPage").removeClass("overlayLoading");
            var suggest = response.data.data;
            for (var i = 0; i < suggest.length; i++) {
              this.suggestarray.push({ idtags: suggest[i].idtags, text: suggest[i].nama });
            }
          }
        }
      } catch (e) {
        this.$catch_error_response(e);
        $("#loadingPage").hide();
        $("#loadingPage").removeClass("overlayLoading");
      }
    },
  },
};
</script>

<style scoped>
.width-input {
  max-width: 50%;
}

.set-input {
  border: 1px solid #c8d0dd;
  margin: 0px 1px;
  text-align: center;
  padding: 5px;
  margin-left: 0px;
  margin-right: 0px;
}

.set-button {
  background: #ffffff;
  border: 1px solid #c8d0dd;
  box-sizing: border-box;
  border-radius: 0px 3px 3px 0px;
  width: 36px;
  padding: 5px;
  color: #206cff;
}

.tagging {
  padding: 0px 16px;
}
</style>
